module.exports = __webpack_public_path__ + "static/media/passenger.95bd7d84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/passenger.svg
// module id = 714
// module chunks = 0